var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 83,
    viewBox: "0 0 84 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.783 28H73.5C75.3565 28 77.137 28.7375 78.4497 30.0503C79.7625 31.363 80.5 33.1435 80.5 35V49C80.5 50.8565 79.7625 52.637 78.4497 53.9498C77.137 55.2625 75.3565 56 73.5 56H69.783C68.9297 62.7666 65.6364 68.9891 60.5211 73.5C55.4058 78.0109 48.8201 80.4999 42 80.5V73.5C47.5695 73.5 52.911 71.2875 56.8492 67.3493C60.7875 63.411 63 58.0696 63 52.5V31.5C63 25.9305 60.7875 20.589 56.8492 16.6508C52.911 12.7125 47.5695 10.5 42 10.5C36.4305 10.5 31.089 12.7125 27.1508 16.6508C23.2125 20.589 21 25.9305 21 31.5V56H10.5C8.64348 56 6.86301 55.2625 5.55025 53.9498C4.2375 52.637 3.5 50.8565 3.5 49V35C3.5 33.1435 4.2375 31.363 5.55025 30.0503C6.86301 28.7375 8.64348 28 10.5 28H14.217C15.0711 21.2341 18.3648 15.0125 23.48 10.5024C28.5952 5.99229 35.1804 3.50378 42 3.50378C48.8196 3.50378 55.4048 5.99229 60.52 10.5024C65.6352 15.0125 68.9289 21.2341 69.783 28ZM10.5 35V49H14V35H10.5ZM70 35V49H73.5V35H70ZM27.16 55.2475L30.87 49.3115C34.2058 51.4011 38.0638 52.5064 42 52.5C45.9362 52.5064 49.7942 51.4011 53.13 49.3115L56.84 55.2475C52.3924 58.034 47.2484 59.5081 42 59.5C36.7516 59.5081 31.6076 58.034 27.16 55.2475Z",
    fill: "url(#paint0_linear_14_223)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14_223",
    x1: 3.5,
    y1: 42.0019,
    x2: 80.5,
    y2: 42.0019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AF598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009EFD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportIcon);
export default __webpack_public_path__ + "static/media/support-icon.74552ad7f2dfa330069d29d3e5fba3ac.svg";
export { ForwardRef as ReactComponent };